import { CustomHeader, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Clipboard, Image, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { colors } from "colors"
import { ShareList } from "./helper/shareList"
import flash from "config/flash"
import { useColor } from "app/theme/getThemes"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"

export const ReferralScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()
  const { userStore } = useStores()
  const memberCode = userStore?.real_member_code
  const referral = userStore?.referral_code

  const megaphoneImage = require("assets/megaphone.png")

  const { height } = useWindowDimensions()
  const { sessionExpired } = useSessionExpired()
  const [referralRulePoint, setReferralRulePoint] = useState("")

  const companyCode = process.env.COMPANY_CODE.toUpperCase()
  const referralUrl = process.env.REFERRAL_URL

  const getActiveReferralRule = async () => {
    await fetch(`${process.env.API_URL}/api/referral/active`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setReferralRulePoint(responseData[0].value)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  useEffect(() => {
    getActiveReferralRule()
  }, [])

  return (
    <>
      <View style={{ backgroundColor: companyTheme.second, height: "100%" }}>
        <CustomHeader headerTitle={translate("referralScreen.title")} withBalls />
        <View style={style.container}>
          <Image source={megaphoneImage} style={style.megaphoneImage} />
          <View style={style.contentContainer}>
            <Text style={style.contentTitle}>{translate("referralScreen.inviteFriend")}</Text>
            <Text>
              {translate("referralScreen.earn")}{" "}
              <Text style={{ color: companyTheme.first }}>
                {referralRulePoint} {translate("referralScreen.point")}
              </Text>{" "}
              {translate("referralScreen.eachFriend")}
            </Text>

            <View style={style.referralCodeContainer}>
              <Text>{translate("referralScreen.yourRefferal")}</Text>
              <View style={style.referralCodeWrapper}>
                <Text style={style.referralCodeText}>{referral}</Text>
                <MaterialIcons
                  onPress={() => {
                    flash("success", translate("referralScreen.copiedToClipboard"))
                    Clipboard.setString(
                      `Invite your friend to join ${companyCode} app and get rewarded\nYour referral code: ${referral}\n${referralUrl}/register/${referral}`,
                    )
                  }}
                  name="content-copy"
                  size={20}
                  color={companyTheme.first}
                />
              </View>
            </View>
            {/* <Text>{translate("referralScreen.copyReferralDescription")}</Text> */}
            {/* <View style={style.shareLogoContainer}>
              <ShareList />
            </View> */}
          </View>
        </View>
        <View style={style.ball1} />
        <View style={style.ball2} />
        <View style={style.ball3} />
        <View style={style.ball4} />
        <View style={style.ball5} />
        <View style={style.ball6} />
        <View style={style.ball7} />
        <View style={style.ball8} />
      </View>
    </>
  )
}
